// Landing hop for a successful Google sign-in (AUTH upgrade-1). The backend's OAuth callback sets
// the session cookies and 302s here; once the boot probe (GET /auth/me) has restored the session,
// this sends the user to the page this tab was signed out of (or the deep link it opened), else
// the `/` workflow chooser. `replace` keeps this hop out of history.
import { useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { Spinner } from '@/components/ui';
import { consumeReturnTo } from '@/lib/returnTo';
import { paths } from '@/routes/paths';

export default function GoogleDonePage() {
  const hydrated = useAuthStore((s) => s.hydrated);
  const currentUser = useAuthStore((s) => s.currentUser);
  // consumeReturnTo is read-once; a re-render (StrictMode, store update) must reuse the answer.
  const target = useRef<string | null>(null);

  if (!hydrated) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '100vh' }}
      >
        <Spinner size="lg" />
      </div>
    );
  }
  if (!currentUser) return <Navigate to={paths.auth.login} replace />;
  target.current ??= consumeReturnTo(currentUser.id) ?? paths.landing;
  return <Navigate to={target.current} replace />;
}
